import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalTitle: {
    defaultMessage: 'Edit Ship To Address',
    description: 'title of a section that will display the address to which the order should be shipped',
    id: 'tY0A8A',
  },
  modalSubTitle: {
    defaultMessage: 'Ship To',
    description: 'subtitle that will display the modal header but above the modal content.',
    id: 'ifT2R4',
  },
  addressOptionsSectionTitle: {
    defaultMessage: 'Validate and Autocorrect Address',
    description: 'title of a form that applies different filter options to a street address value',
    id: 'V3Uu2r',
  },
  addressOptionsStoreSettingSubtitle: {
    defaultMessage: 'To manage automatic address validation for imported orders, go to <a>store settings.</a>',
    description: 'subtitle with link to allow user to update their store settings for address validation',
    id: '9OQfg9',
  },
  validateAddressLabel: {
    defaultMessage: 'Validate and autocorrect address',
    description: 'label for a checkbox that when clicked will validate and autocorrect the current street address value',
    id: 'mPVnRu',
  },
  lockAddressLabel: {
    defaultMessage: 'Lock to prevent address updates from store {lockIcon}',
    description:
      'label for a checkbox that when clicked will "lock" a street address value from future updates that might be applied from an external source, specifically the marketplace where the order was placed',
    id: 'MxVC7c',
  },
  saveButton: {
    defaultMessage: 'Save',
    description: 'text for a button that saves the users changes',
    id: 'qjBa1x',
  },
  saveButtonApplyToAll: {
    defaultMessage: 'Apply to all open shipments',
    description: 'text for a button that saves the users changes',
    id: 'bsmclW',
  },
  defaultErrorMessage: {
    defaultMessage:
      'An unknown error occurred and we could not save the address changes. Please try again later and if the problem persists contact support.',
    description: 'a default error message letting the user know the changes they made to the shipping address were not saved',
    id: 'M7B3cj',
  },
  pasteAddressHeader: {
    defaultMessage: 'Speed up with copy & paste',
    description: 'title for an input field that will autocomplete a users form',
    id: 'tNwZ9y',
  },
  pasteAddressDescription: {
    defaultMessage: 'Paste or type address to fill out the form quickly.',
    description:
      'descriptive text for an input field that will autocomplete all adjacent form fields from the values a user pastes or types',
    id: 'qipf8W',
  },
  pasteAddressLabel: {
    defaultMessage: 'US Address',
    description: 'label indicating that a user can paste a US address into the textarea',
    id: '1MncQZ',
  },
  parseAddressErrorMessage: {
    defaultMessage: 'Unable to parse the provided address',
    description: 'an error message display when our software fails to parse an address from a user-supplied text input value',
    id: 'poJJy6',
  },
  pasteAddressPlaceholder: {
    description: 'Placeholder text for paste address filed in ship to modal',
    defaultMessage: 'Recipient Name\n4301 Bull Creek Rd\nAustin, TX 78731\n512-555-1234',
    id: 'qzediR',
  },
  validationErrorMessage: {
    defaultMessage:
      'We could not validate the address due to an unknown error. Please wait a few moments and try again. If the problem persists, please contact ShipStation support.',
    description: 'a default error message letting the user know the validation failed',
    id: 'u4L5Jm',
  },
  validationErrorTitle: {
    defaultMessage: 'Failed to Validate Address',
    description: 'a default error title letting the user know the validation failed',
    id: 'DIw21w',
  },
  revertTooltipBody: {
    defaultMessage: 'Reverts address to the original Ship To Address, seen in the Order Summary',
    description: 'Revert tooltip message',
    id: 'WV7MYy',
  },
  revertErrorMessage: {
    defaultMessage:
      'We could not revert the address due to an unknown error. Please wait a few moments and try again. If the problem persists, please contact ShipStation support.',
    description: 'a default error message letting the user know the revert failed',
    id: 'FCQanB',
  },
  revertErrorTitle: {
    defaultMessage: 'Failed to Revert Address',
    description: 'a default error title letting the user know the revert failed',
    id: 'OqzA6t',
  },
  validate: {
    defaultMessage: 'Validate',
    id: 'SgZIH3',
    description: 'text on button to validate an address in the user input',
  },
  validating: {
    defaultMessage: '{spinner} <i>Validating</i>',
    id: 'UW2+y2',
    description: 'text to inform the user accompanied by a loading spinner that a validating process is occurring',
  },
  notValidated: {
    defaultMessage: '{icon} Not Validated',
    id: 'Fe6Esx',
    description: 'text to inform the user accompanied by a an icon that the address in the form is not yet validated.',
  },
  notValidatedNoIcon: {
    defaultMessage: 'Not Validated',
    id: 'C8/AAP',
    description: 'text to inform the user the address in the form is not yet validated.',
  },
  verificationBannerErrorMessage: {
    defaultMessage: 'Address validation failed. {verificationMessage}',
    id: 'YkAjBz',
    description: 'text to inform the user that the validation has failed accompanied by the reason which it failed.',
  },
});

export default messages;
